import styles from './MenuContact.module.css'
import WaitLoader from "../../WaitLoader/WaitLoader";
import {Map, ObjectManager, withYMaps, YMaps, ZoomControl} from "@pbe/react-yandex-maps";
import React, {useEffect, useMemo, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import {geometry} from "yandex-maps";
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import useFormValidator, {FormValidatorInt} from "../../FormValidator/FormValidator";
import {Helmet} from "react-helmet";
interface DeliveryOptionInt
{
    yaMapApiKey:string
    yaMapSuggestKey:string
}


interface AddFeedBackInt
{
    author:string;
    text:string;
    type:number;
    parent:number;
    phone?:string;
    eMail?:string;
    xData?:string;
    yData?:string;
    capt:string;
}

interface FeedBackInt {
    name:string
    eMail?:string
    phone?:string
    theme?:string
    text:string
    capt:string
}

interface YMFeatureObjectInt
{
    type: string
    id:number
    geometry: {
        type:string
        coordinates: number[]
    }
    properties: {
        hintContent: string
        balloonContent: string
        city: string
        isCluster: boolean
        clusterCount: number
        postCode:number
        [key:string]: any

    }
}


export default function MenuContact(){
    const errorLineRef = useRef<ErrorLineItemRef>(null)
    const refPointManager = useRef<any>(undefined)



    const addFeedBackData = useRef<AddFeedBackInt>()
    const [ldrAddFeedback,rsAddFeedback,exAddFeedback] = useApiQuery("/appeal/add","post",addFeedBackData);
    const [addFeedback, setAddFeedback] = useState()



    const [lockForm, setLockForm] = useState(false)
    const [acceptPd, setAcceptPd]= useState(false)

    const [formData,setFormData]=useState<FormValidatorInt[]>([{
        val:"",
        id:"capt",
        errText: "Не корректный код с картинки",
        regExp: /^[0-9]{4}$/ui,
        isCheck: true,
        valid: true
    }])
    const [validate,validateById,getValue,setValue,getErrText] = useFormValidator(formData)



    const dataCapt = useRef({
        name: "pAppeal",
        len:4,
        useDigit: true
    })
    const [ldrDataCapt,rsDataItemCapt,executeLoadDataCapt] = useApiQuery("/auth/capt","post",dataCapt);
    const [capt,setCap]=useState("")


    const [feedBack, setFeedBack] = useState<FeedBackInt>({
        name: "",
        text:"",
        capt:""
    })

    const [centerView, setCenterView] = useState<number[]>([])
    const [zoom, setZoom] = useState(16)

    //Выбранная точка в формате YMFeatureObjectInt при клике по значку данные из yandexObj
    const [selectedPoint, setSelectedPoint] = useState<YMFeatureObjectInt>()

    //Опции доставки ключи и тп
    const deliveryOptionData = useRef()
    const [ldrDeliveryOption,rsDeliveryOption,exDeliveryOption] = useApiQuery("/sell/sim/delivery/option","get",deliveryOptionData);
    const [deliveryOption, setDeliveryOption] = useState<DeliveryOptionInt>()

    const officeListData = useRef()
    const [ldrOfficeList,rsOfficeList,exOfficeList] = useApiQuery("/ref/office/list","get",officeListData);
    const [officeList, setOfficeList] = useState<any[]>([])

    const [bound, setBound] = useState([[55.0454, 82.8997],[55.0491,82.9104]])
    const refMap = useRef<any>()
    const mapWidth =  window.innerWidth-60
    const [mapSize, setMapSize]= useState([mapWidth > 1000 ? 800: mapWidth,window.innerWidth < 610 ? window.innerWidth-20 : 400])
    const yApi = useRef<any>(null)
    const [pointList,setPointList] = useState<YMFeatureObjectInt[]>([
        {
            id: 0,
            type:"Feature",
            geometry: {
                type: "Point",
//                            coordinates: [item?.longitude, item?.latitude]
                coordinates: [82.904955,55.047028].reverse()
            },
            properties: {
                hintContent: "Новосибирск, Железнодорожная 15/1 оф 39",
                balloonContent: "",
                city: "Новосибирск",
                isCluster:  false,
                clusterCount: 0,
                postCode: 0,
                typeId: 0
            }
        }

    ])

    useEffect(()=>{
        loadDeliveryOption()
    },[deliveryOptionData])


//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    useEffect(()=>{
        exOfficeList().then((e)=>{
            if(e?.success && Array.isArray(e?.payload))
            {
                setOfficeList(e?.payload?.map((item,idx)=>{
                    const active = idx ===0
                    return {...item, active: active}
                }))
                const fArray = e?.payload?.map((item,idx)=>{
                    const lp:YMFeatureObjectInt = {
                        id: item?.id,
                        type: "Feature",
                        geometry: {
                            type: "Point",
                            coordinates: [item?.latitude,item?.longitude],

                        },
                        properties:{
                            hintContent: item?.address,
                            isCluster: false,
                            balloonContent: "",
                            clusterCount: 0,
                            city: "",
                            postCode:0
                        }
                    }
                    if(idx ===0 ) setCenterView(lp?.geometry?.coordinates )

                    return lp
                })
                setPointList(fArray)
            }
        })
    },[officeListData])
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    useEffect(()=>{
        loadNewCapt()
    },[dataCapt])
    const loadNewCapt= ()=>
    {
        executeLoadDataCapt().then((e)=>{
            if(e?.success)setCap(e?.payload)
        })

    }


    const loadDeliveryOption = () =>{
        exDeliveryOption().then((e)=>{
            if(e?.success)
            {
                const payload = e?.payload
                setDeliveryOption({
                    yaMapApiKey: payload?.yaMapApiKey,
                    yaMapSuggestKey: payload?.yaMapSuggestKey,
                })
                return

            }
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки опций",true,5000)
        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки опций",true,5000)
        })
    }

    const YaApiItem = ({ymaps}:any)=> {
        if(ymaps )
        {
            yApi.current = ymaps
        }
        return null
    }

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const ButtonWithYMap = useMemo(()=>{
        return withYMaps(YaApiItem, true,['route','geocode'])
    },[Map])

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const handlePointClick = (e:any) =>{
        const  objectId = e.get('objectId')
        console.log("clicked",objectId)
        const filter = pointList.filter((item)=>{
            if(item.id === objectId) return true
            return false
        })
        //console.log("filter",filter)
        if (filter.length)  setSelectedPoint(filter[0])
    }
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    const handleOfficeClick = (id:number) => {
        setOfficeList( officeList?.map((item,idx)=>{
            item.active = false
            if(idx === id)
            {
                item.active = true
                setZoom(item?.zoom)
                setCenterView([item?.latitude, item?.longitude])
            }
            return item
        }) )
    }
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    const buildOfficeList = ()=>{
        return officeList?.map((item,idx)=>{
            return(
                <div key={idx}>
                    <div className={styles.ofItem} key={idx} onClick={()=> handleOfficeClick(idx)}>
                        <div className={styles.itmNCont}>
                            <div className={[styles.selItm, item?.active ? styles.selItmAct : ""].join(' ')}></div>
                            <div className={styles.ofName}>[ {item?.name} ]</div>
                        </div>
                        <div className={styles.ofAdd}>{item?.address}</div>

                    </div>
                    {item?.active &&
                        <div className={styles.itmActCont}>
                            {item?.phone &&
                                <div>
                                    <span>Тел. : </span><a href={"tel:"+item?.phone}>{item?.phone}</a>
                                </div>
                            }

                            {item?.eMail &&
                                <div>
                                    <span>e-Mail : </span><a href={"mailto:"+item?.eMail}>{item?.eMail}</a>
                                </div>
                            }
                            {item?.workTime &&
                                <div>
                                    <span>Режим : </span>{item?.workDay + "  " + item?.workTime}
                                </div>
                            }
                        </div>
                    }

                </div>
            )


        })
    }

    const handleAdd = () =>{
        if(!validate())return
        if(!feedBack?.eMail?.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ui) && !feedBack?.phone?.match(/[0-9]{10}$/ui) && errorLineRef?.current)
        {
            errorLineRef.current.show("Укажите способ связи, введите телефон или e-Mail",true,3000)
            return;
        }

        if(!feedBack?.text && errorLineRef?.current && feedBack?.text?.length < 5)
        {
            errorLineRef.current.show("Слишком маленький текст",true,3000)
            return;
        }

        if(!feedBack?.name && errorLineRef?.current && feedBack?.name?.length < 3)
        {
            errorLineRef.current.show("Не корректное имя ",true,3000)
            return;
        }

        const phoneReg = feedBack?.phone?.match(/[0-9]{10}$/ui)
        const phone = phoneReg ? phoneReg[0]: undefined


        addFeedBackData.current = {
            phone: phone,
            eMail: feedBack?.eMail,
            author: feedBack?.name,
            capt: getValue("capt"),
            type:1,
            parent:0,
            text: feedBack?.text,
        }
        console.log(addFeedBackData?.current)
        exAddFeedback().then((e)=>{
            loadNewCapt()
            if(e?.success)
            {
                if(errorLineRef.current)errorLineRef.current.show("Сообщение отправлено",false,5000)
                return

            }
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ?  e?.errorAsString : "Ошибка сервера",true,3000)
        }).catch((e)=>{
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ?  e?.errorAsString : "Ошибка сервера",true,3000)
        })


    }

    return(
        <div className={styles.mCont} >
            <Helmet>
                <title>sim-unlim : Контакты</title>
                <link rel="canonical" href="https://sim-unlim.com/contact" />
                <meta name="description" content="Офис Якутия Новосибирск Железнодорожная телеграм ватсап" />
            </Helmet>

            <div className={styles.title}>Наши офисы</div>
            <WaitLoader loading={ldrOfficeList} api={rsOfficeList} onlyLoading={true}>
                <div className={ styles.ofCnt}>
                    {buildOfficeList()}
                </div>
            </WaitLoader>
            <div className={styles.errCont}>
                <ErrorLineItem ref={errorLineRef}></ErrorLineItem>
            </div>
            <WaitLoader loading={ldrDeliveryOption} api={rsDeliveryOption} onlyLoading={true}>
                <div className={styles.mainCont}>

                    <div style={{height:"100%"}}>
                        <YMaps query={{apikey:deliveryOption?.yaMapApiKey,lang:"ru_RU",suggest_apikey: deliveryOption?.yaMapSuggestKey}}   >
                            <Map
                                state={{
                                    center: centerView,
                                    zoom: zoom,

                                }}

                                instanceRef={(e)=>{
                                }}
                                height={mapSize[1]}
                                width={mapSize[0]}
                                options={{suppressMapOpenBlock: true,suppressObsoleteBrowserNotifier:true,yandexMapDisablePoiInteractivity: true,copyrightLogoVisible:false,copyrightUaVisible: false,}}
                                //instanceRef={ref}
                                onClick={(e:any)=>{
                                    //console.log(e.get("coords"))
                                    //setSelectedPoint(undefined)
                                }}



                            >
                                <ZoomControl  options={{}} />
                                <ObjectManager
                                    options={{
                                        clusterize: false,
                                        gridSize: 0,
                                    }}
                                    instanceRef = {(e:any)=>{
                                        try {
                                            if(refPointManager.current )
                                            {
                                                refPointManager.current?.events.remove('click',handlePointClick)
                                            }
                                            if(e === null) return
                                            refPointManager.current = e
                                            e.events.remove('click',handlePointClick)
                                            e.events.add('click',handlePointClick)
                                        } catch (e) {console.log(e)}
                                    }}
                                    objects={{
                                        openBalloonOnClick: false,
                                        preset: "islands#greenDotIcon",
                                    }}
                                    clusters={{
                                        preset: "islands#greenClusterIcons",
                                    }}
                                    features = {{type: "FeatureCollection", features: pointList}}
                                    modules={[
                                        "objectManager.addon.objectsBalloon",
                                        "objectManager.addon.objectsHint",
                                    ]}
                                />

                                <ButtonWithYMap />
                            </Map>
                        </YMaps>

                    </div>


                </div>

            </WaitLoader>
            <MainFormTemplate title={"Форма обратной связи"} maxWidth={"800px"}>
                <div className={"row"}>
                    <div className={"col-sm-6"}>
                        <InputItem
                            val={feedBack?.name ? feedBack?.name : ""}
                            mode={"ei"}
                            info={"Как к Вам обращаться"}
                            placeHolder={"Имя"}
                            title={"Имя"}
                            regExp={/^[а-яaz\s]{3,}$/ui}
                            onBlur={(e)=> setFeedBack({...feedBack, name: (e)})}
                        ></InputItem>
                    </div>
                    <div className={"col-sm-6"}>
                        <InputItem
                            val={feedBack?.eMail ? feedBack?.eMail : ""}
                            mode={"ei"}
                            info={"Почтовый ящик"}
                            placeHolder={"e-Mail"}
                            title={"e-Mail"}
                            regExp={/(^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$)|(^$)/ui}
                            onBlur={(e)=> setFeedBack({...feedBack, eMail: (e)})}
                        ></InputItem>
                    </div>

                </div>
                <div className={"row"}>
                    <div className={"col-sm-6"}>
                        <InputItem
                            val={feedBack?.phone ? feedBack?.phone : ""}
                            mode={"ei"}
                            info={"Телефон для связи"}
                            placeHolder={"Телефон"}
                            type={"numeric"}
                            title={"Телефон"}
                            regExp={/(((\+7)|(8)|(^))\d[0-9]{9}$)|(^$)/ui}
                            onBlur={(e)=> {
                                const p = e?.match(/[0-9]{10}$/ui)
                                let k = e
                                if(p) k = "+7" + p[0]
                                setFeedBack({...feedBack, phone: (k)})
                            }}
                        ></InputItem>
                    </div>
                    <div className={"col-md-6 order-1 order-md-1"}>
                        <label htmlFor="exampleInputEmail1 m-0" className="form-label col-form-label-sm">Проверочный код</label>
                        <div className={[styles.captLine].join(' ')}>
                            <i className={['bx bx-refresh',styles.capRef].join(' ')} onClick={()=>{loadNewCapt() }}></i>
                            <div className={styles.captContainer}>
                                <img className={styles.capImg} src={capt} onClick={()=>{loadNewCapt() }}/>
                            </div>
                            <input type="text" className="form-control" placeholder={"XXXX"} style={{width: '4.5em'}}
                                   value={getValue("capt")}
                                   onBlur={()=>validateById("capt")}
                                   inputMode={"numeric"}

//                                   onChange={(e)=>setFeedBack({...feedBack, capt: e.target?.value?.trim()})}
                                   onChange={(e)=>setValue("capt",e.target.value)}

                                   maxLength={4}


                            ></input>

                        </div>
                        <div  className={["", styles.errMessage].join(' ')}>{getErrText("capt")}</div>


                    </div>


                </div>

                <div className={"row g-3 mb-3"}>
                    <div className={"col-sm-12"}>
                        <InputItem
                            val={feedBack?.text ? feedBack?.text : ""}
                            mode={"ei"}
                            info={"Телефон для связи"}
                            placeHolder={"Текст обращения"}
                            title={""}
                            titleShift={-6}
                            inputType={2}
                            lineCount={5}
                            regExp={/^[\w\W]{10,}$/ui}
                            onBlur={(e)=> setFeedBack({...feedBack, text: (e)})}
                        ></InputItem>
                    </div>
                </div>

                <div className="row g-3 mb-3">
                    <div className="col-12 ">
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="gridCheck"
                                   style={{cursor:"pointer"}}
                                   checked={acceptPd}
                                   onChange={()=>setAcceptPd(!acceptPd)}

                            ></input>
                            <label className="form-check-label col-form-label-sm" htmlFor="gridCheck" style={{cursor:"pointer",padding:"0"}}>
                                Даю согласие на обработку данных
                            </label>
                        </div>
                    </div>

                </div>

                <ErrorLineItem ref={errorLineRef} ></ErrorLineItem>

                <div className={"row my-2"}>
                    <div className="col-12">
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-face"
                                    disabled={!acceptPd}
                                    onClick={()=>handleAdd()}
                            >Отправить</button>
                            <WaitLoader loading={ldrAddFeedback} api={rsAddFeedback} onlyLoading={true}>

                            </WaitLoader>

                        </div>

                    </div>

                </div>



            </MainFormTemplate>
        </div>
    )
}